import Masonry from 'masonry-layout';
import LazyLoad from "vanilla-lazyload";

//https://imagesloaded.desandro.com/ must be install


const masonryLayout = () => {

        var imagesLoaded = require('imagesloaded');

        // class of the masonry grid here
        const grid = document.querySelector(".masonry-grid");
        const gridSizer = document.querySelector(".grid-sizer");
        const gridItem = document.querySelectorAll('.grid-item');
        const itemSelector = '.grid-item';

        if (grid) {

            // -------------- use masonry ----

            let masonry = new Masonry(grid, {
                // columnWidth: '.grid-sizer',
                columnWidth: gridSizer,
                itemSelector: itemSelector,
                percentPosition: true,
                // gutter: 30
            });

            imagesLoaded(grid, function () {
                masonry.layout()

                // Add class loaded for animation fade
                for (var i = 0; i < gridItem.length; i++) {
                    gridItem[i].classList.add('grid-item-loaded')
                }

                // $('.grid-loader').fadeOut();
                new LazyLoad({
                    elements_selector: itemSelector,
                    threshold: 200,
                    callback_loaded: masonry.layout(),
                    unobserve_completed: true // Stop observi
                });
            });

            // ------------- end Masonry 
        }
};

export default masonryLayout;
